import script from "./Delete.vue?vue&type=script&setup=true&lang=js"
export * from "./Delete.vue?vue&type=script&setup=true&lang=js"

import "./Delete.vue?vue&type=style&index=0&id=c64888a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c64888a4"]])

export default __exports__